// extracted by mini-css-extract-plugin
export default {"content":"styles_content__NEEN0","title":"styles_title__2UfuH","articles":"styles_articles__za5wo"};